export enum CashRegisterMovementType {
  CashOpening,
  Deposit,
  Withdrawal
}